import { useState, useCallback } from "react";
import { PerfilesPuesto } from "../api";
import { useAuth } from "./useAuth";

const api = new PerfilesPuesto();

export function usePerfilesPuesto() {
  const { accessToken } = useAuth();
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [pages, setPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAll = useCallback(
    async (filters = {}) => {
      setLoading(true);
      setError(null);
      try {
        const result = await api.getAll(accessToken, filters);
        setData(result.data || []);
        setTotal(result.total || 0);
        setPages(result.pages || 1);
        setCurrentPage(result.page || filters.page || 1);
        return result;
      } catch (err) {
        setError(err?.message || "Error al cargar perfiles");
      } finally {
        setLoading(false);
      }
    },
    [accessToken]
  );

  const fetchById = useCallback(
    async (id) => {
      setLoading(true);
      setError(null);
      try {
        const result = await api.getById(accessToken, id);
        return result.data;
      } catch (err) {
        setError(err?.message || "Error al cargar el perfil");
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [accessToken]
  );

  const create = useCallback(
    async (formData) => {
      setLoading(true);
      setError(null);
      try {
        const result = await api.create(accessToken, formData);
        return result;
      } catch (err) {
        setError(err?.message || "Error al crear el perfil");
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [accessToken]
  );

  const update = useCallback(
    async (id, formData) => {
      setLoading(true);
      setError(null);
      try {
        const result = await api.update(accessToken, id, formData);
        return result;
      } catch (err) {
        setError(err?.message || "Error al actualizar el perfil");
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [accessToken]
  );

  const toggleEstado = useCallback(
    async (id, activo) => {
      try {
        const result = await api.toggleEstado(accessToken, id, activo);
        setData((prev) => prev.map((p) => (p.id === id ? { ...p, activo } : p)));
        return result;
      } catch (err) {
        setError(err?.message || "Error al cambiar el estado");
        throw err;
      }
    },
    [accessToken]
  );

  const remove = useCallback(
    async (id) => {
      try {
        await api.delete(accessToken, id);
        setData((prev) => prev.filter((p) => p.id !== id));
      } catch (err) {
        setError(err?.message || "Error al eliminar el perfil");
        throw err;
      }
    },
    [accessToken]
  );

  return { data, total, pages, currentPage, loading, error, fetchAll, fetchById, create, update, toggleEstado, remove };
}
